import { Fragment } from 'react'

import type { CharacteristicSlotType } from '@/types'
import {
  formatSlotValue,
  resolveSlotsCount,
  slotsToFormValues,
} from '@/utils/search/characteristics/slottedCharacteristics'

import cn from './SlotsValue.module.scss'

type SlotsValueProps = {
  slots?: CharacteristicSlotType[] | null
  slotsCount?: number | null
  unit?: string
  className?: string
}

function SlotsValue({ slots, slotsCount, unit, className }: SlotsValueProps) {
  const values = slotsToFormValues(
    slots,
    resolveSlotsCount({ slots, slotsCount })
  )
  if (!values.some(Boolean)) return null

  return (
    <span className={[cn.slotsValue, className].filter(Boolean).join(' ')}>
      {values.map((value, index) => (
        <Fragment key={index}>
          {index > 0 && <span className={cn.separator}>×</span>}
          {value ? (
            <span>{formatSlotValue(value)}</span>
          ) : (
            <span
              className={cn.emptySlot}
              title={`Присоединение ${index + 1} не заполнено`}
            />
          )}
        </Fragment>
      ))}
      {unit && <span className={cn.unit}>{unit}</span>}
    </span>
  )
}

export default SlotsValue
